import { getAgsApiUrl, smb_fetch } from '@/api/operator/fetch';
import { GetCustomerList, GetLeadList, UnbindLeadContact, BindLeadContact } from '../interface';

export const getOnlineSalesRelation = (data: GetCustomerList) => {
  const url = getAgsApiUrl('online-sales', 'relation/search');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    data,
  }, true, false);
};

export const getOnlineSalesLead = (data: GetLeadList) => {
  const url = getAgsApiUrl('online-sales', 'lead/search');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    data,
  }, true, false);
};

export const getCorpTagConfig = () => {
  const url = getAgsApiUrl('online-sales', 'get-corp-tag-config');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    data: {},
  }, true, false);
};

export const bindLeadContact = (data: BindLeadContact) => {
  const url = getAgsApiUrl('online-sales', 'bind');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    loadingTip: '关联线索联系人，请稍后',
    data,
  }, true, false);
};

export const unbindLeadContact = (data: UnbindLeadContact) => {
  const url = getAgsApiUrl('online-sales', 'unbind');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    loadingTip: '解除线索联系人关联，请稍后',
    data,
  }, true, false);
};

export const reletionDownload = (data: GetCustomerList) => {
  const url = getAgsApiUrl('v2/relation', 'download');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    data,
  }, true, false);
};
